import React, { useState } from 'react';
import ListSwitch from "../../components/List/ListSwitch";
import GridTabFolding from "../../components/Grid/GridTabFolding";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheck, faFemale, faXmark} from "@fortawesome/free-solid-svg-icons";
import styles from "../../components/Grid/GridTabFolding.module.css";

const ListTestPage = props => {
    const [listData, setListData] = useState([
        { key: 0, name: "Option 1", isSwitchActive: true, userRegisteredLabel: "active", userNonRegisteredLabel: "inactive"},
        { key: 1, name: "Option 2", isSwitchActive: false, userRegisteredLabel: "active", userNonRegisteredLabel: "inactive"},
        { key: 2, name: "Option 3", isSwitchActive: false, userRegisteredLabel: "" },
        { key: 3, name: "Option 4", isSwitchActive: true, userRegisteredLabel: "" },
        { key: 4, name: "Option 5", isSwitchActive: false },
    ]);

    const [listDataFolding, setListDataFolding] = useState([
        {
            key: 0,
            col1: "Option 1",
            col3: "Option 1",
            col2: true,
            data: [
                {label: "Date d'inscription", value: "13/13/2055"},
                {label: "Date de la dernière connexion", value: "03/13/1825"},
                {label: "Nombre d'inscritpion", value: "887"},
                {label: "Liste d'attente", value: "1"},
                {label: "Annulations", value: "5"},
                {label: "Absence", value: "1"},
            ]
        },
        { key: 1, col1: "Option 2", col3: "Option 2", col2: false, data: [ {label: "Date d'inscription", value: "13/13/2055"}, {label: "Date d'inscription", value: "13/13/2055"} ] },
        { key: 2, col1: "Option 3", col3: "Option 3", col2: false, data: [ {label: "Date d'inscription", value: "13/13/2055"}, {label: "Date d'inscription", value: "13/13/2055"} ] },
        { key: 3, col1: "Option 4", col3: "Option 4", col2: true, data: [ {label: "Date d'inscription", value: "13/13/2055"}, {label: "Date d'inscription", value: "13/13/2055"} ] },
        { key: 4, col1: "Option 5", col3: "Option 5", col2: false, data: [ {label: "Date d'inscription", value: "13/13/2055"}, {label: "Date d'inscription", value: "13/13/2055"} ] },
    ]);

    const handleToggleSwitch = (key) => {
        const newListData = listData.map(item => {
            if (item.key === key) {
                return { ...item, isSwitchActive: !item.isSwitchActive };
            }
            return item;
        });
        setListData(newListData);
    };


    const listDataFold = [
        {
            id: 1,
            name: "Wilson Ballon",
            sexe: <FontAwesomeIcon icon={faFemale} className={`${styles.icone} ${styles.iconeFaMale}`}/>,
            actif: <FontAwesomeIcon icon={faCheck} className={`${styles.icone} ${styles.iconeFaCheck}`}/>,
            details: {
                dateInscription: "01/01/2022",
                derniereConnexion: "02/02/2024",
                inscriptions: "67",
                presences: "40",
                absences: "3",
            }
        },
        {
            id: 2,
            name: "Victor Desroches",
            sexe: <FontAwesomeIcon icon={faFemale} className={`${styles.icone} ${styles.iconeFaMale}`}/>,
            actif: <FontAwesomeIcon icon={faCheck} className={`${styles.icone} ${styles.iconeFaCheck}`}/>,
            details: {
                dateInscription: "15/05/2021",
                derniereConnexion: "30/01/2024",
                inscriptions: "52",
                presences: "45",
                absences: "2",
            }
        },
        {
            id: 3,
            name: "Jeanne Desroches",
            sexe: <FontAwesomeIcon icon={faFemale} className={`${styles.icone} ${styles.iconeFaFemale}`}/>,
            actif: <FontAwesomeIcon icon={faCheck} className={`${styles.icone} ${styles.iconeFaCheck}`}/>,
            details: {
                dateInscription: "15/05/2023",
                derniereConnexion: "30/01/2024",
                inscriptions: "18",
                presences: "15",
                absences: "3",
            }
        },
        {
            id: 4,
            name: "Meryl Lalumeuse",
            sexe: <FontAwesomeIcon icon={faFemale} className={`${styles.icone} ${styles.iconeFaFemale}`}/>,
            actif: <FontAwesomeIcon icon={faXmark} className={`${styles.icone} ${styles.iconeFaXmark}`}/>,
            details: {
                dateInscription: "15/05/2021",
                derniereConnexion: "30/01/2024",
                inscriptions: "105",
                presences: "104",
                absences: "1",
            }
        },
    ];

    const columns = [
        { header: 'NOM', field: 'name' },
        { header: 'SEXE', field: 'sexe' },
        { header: 'ACTIF', field: 'actif' },
    ];


    return (
        <div className="content">
            <ListSwitch listData={listData} handleToggleSwitch={handleToggleSwitch} title={"Ma belle liste"} description={"Ce composant permet de faire l'appel"}/>
            <br/>
            <br/>

            <GridTabFolding listData={listDataFold} columns={columns} />

        </div>
    );
};

export default ListTestPage;
